export default function ChatBox({ children }: { children: any }) {
  return (
    <div className="flex flex-col h-full items-center justify-between gap-4 rounded-md overflow-auto">
      {children}
    </div>
  );
}
